import upgraderApi from './upgraderApi'

export const normalizeSkin = (item) => ({
  ...item,
  price: Number(item.price ?? item.cost ?? 0)
})

export const upgraderGameApi = {
  getInventory: () => upgraderApi.getAvailableItems().then((items) => items.map(normalizeSkin)),
  getTargets: async (sourceId) => {
    const { multipliers } = await upgraderApi.getMultipliers(sourceId)
    return Object.fromEntries(Object.entries(multipliers).map(([key, items]) => [key, Array.isArray(items) ? items.map(normalizeSkin) : []]))
  },
  getChance: (sourceId, targetId) => upgraderApi.calculateChance(sourceId, targetId),
  upgrade: (sourceId, targetId) => upgraderApi.performUpgrade(sourceId, targetId)
}
